var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatelliteTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1744 15.148H1.09605C0.713435 15.148 0.400391 14.8349 0.400391 14.4523V6.13926C0.400391 5.75665 0.713435 5.4436 1.09605 5.4436H14.1396C14.5222 5.4436 14.8352 5.75665 14.8352 6.13926V14.4523C14.87 14.8349 14.557 15.148 14.1744 15.148Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82617 6.86987H10.7653V13.7569H1.82617V6.86987Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 15.1476H3.84423V16.3998H2.07031V15.1476Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4609 15.1476H13.2349V16.3998H11.4609V15.1476Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4616 5.0959V5.44372H9.33984V5.0959C9.33984 4.50459 9.8268 4.05241 10.4181 4.05241C10.9746 4.01763 11.4616 4.50459 11.4616 5.0959Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0016 4.0869L8.33203 1.68689",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4352 1.68689L10.7656 4.0869",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8519 1.79133C13.2361 1.79133 13.5476 1.47988 13.5476 1.09568C13.5476 0.71148 13.2361 0.400024 12.8519 0.400024C12.4677 0.400024 12.1562 0.71148 12.1562 1.09568C12.1562 1.47988 12.4677 1.79133 12.8519 1.79133Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91245 1.79133C8.29665 1.79133 8.60811 1.47988 8.60811 1.09568C8.60811 0.71148 8.29665 0.400024 7.91245 0.400024C7.52825 0.400024 7.2168 0.71148 7.2168 1.09568C7.2168 1.47988 7.52825 1.79133 7.91245 1.79133Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8172 8.53944C13.2782 8.53944 13.652 8.1657 13.652 7.70466C13.652 7.24362 13.2782 6.86987 12.8172 6.86987C12.3562 6.86987 11.9824 7.24362 11.9824 7.70466C11.9824 8.1657 12.3562 8.53944 12.8172 8.53944Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8172 11.4257C13.2782 11.4257 13.652 11.0519 13.652 10.5909C13.652 10.1298 13.2782 9.7561 12.8172 9.7561C12.3562 9.7561 11.9824 10.1298 11.9824 10.5909C11.9824 11.0519 12.3562 11.4257 12.8172 11.4257Z",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 12.6434H13.478",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 13.7563H13.478",
    stroke: "#01152E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliteTv);
export default __webpack_public_path__ + "static/media/satellite-tv.5a847a5c62af89029ced58f40c0e8148.svg";
export { ForwardRef as ReactComponent };